import { postForFile } from './files';

export { downloadBlob } from './files';
export type { FileResult } from './files';

export interface ExpenditureLedgerSummary {
  company: string;
  pdf_pages: number[];
  particulars: number;
  pdf_total: number | null;
  extracted_total: number;
  ledger_lines: number;
  filtered_lines: Record<string, number>;
  adjustment_totals: Record<string, number>;
  fuzzy_matches: { ledger: string; particular: string }[];
  ledger_only: string[];
  warnings: string[];
}

export function buildExpenditureLedger(pdf: File, ledger: File) {
  const form = new FormData();
  form.append('pdf_file', pdf);
  form.append('ledger_file', ledger);
  return postForFile<ExpenditureLedgerSummary>(
    '/expenditure-ledger/build',
    form,
    'Expenditure_Ledger.xlsx',
    'Building the expenditure ledger failed'
  );
}
